<template>
  <div
    class="sm:w-full sm:h-[52vw] w-[1000px] h-[563px] bg-back-1 flex justify-center items-center relative overflow-hidden"
    :class="{
      landscape: landscape,
      portrait: !landscape,
    }"
  >
    <div class="video-container h-full w-full">
      <video
        ref="videoRef"
        loop
        class="object-contain h-full rounded-[12px] overflow-hidden"
        autoplay
        muted
        :src="item.video_url"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { Character } from '~/api/interface/character';

const props = defineProps<{
  item: any;
  character: Character;
}>();

const videoRef = ref<HTMLVideoElement>();
const landscape = ref(false);

function getVideoStartTime(src?: string) {
  if (src?.endsWith('new_face.mp4')) {
    return props.character.config?.gender === 'Male' ? 3 : 11;
  }
  return 0;
}

const onLoadedMetadata = () => {
  if (!videoRef.value) return;
  // 判断横竖屏
  const videoWidth = videoRef.value.videoWidth;
  const videoHeight = videoRef.value.videoHeight;
  if (videoWidth > videoHeight) {
    landscape.value = true;
  } else {
    landscape.value = false;
  }
  videoRef.value.currentTime = getVideoStartTime(props.item.video_url);
};

onMounted(() => {
  if (videoRef.value) {
    onLoadedMetadata();
  }
});
</script>

<style scoped lang="scss">
.portrait {
  padding: 16px 0;
  background-color: var(--purple-1);

  video {
    border-radius: 16px;
  }
}
</style>
